import { record } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import type { ApiTableCommandFactory } from '../ApiTableModel';

interface DeleteTableReportsCommand {
  deletedReports: { id: string }[];
}

export const deleteTableReports: ApiTableCommandFactory<
  DeleteTableReportsCommand
> = (cmdContext) => async (command) => {
  const { reports } = cmdContext.getState();

  const updatedReports = pipe(
    reports,
    record.filter(
      (report) => !command.deletedReports.some((d) => d.id === report.id),
    ),
  );

  cmdContext.updateState((draft) => {
    draft.reports = updatedReports;
  });
};
